import { AppBar, Toolbar, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { BackButton, ReplaceButton } from '$common/buttons'
import { t } from '$i18n'

const TitleTypography = styled(Typography)`
  margin-right: 7px;
  flex-grow: 1;
  margin-left: auto;
`

interface Prop {
  title: string
  canReplace?: boolean
  onBack: () => unknown
  onReplace: () => unknown
}

export function AppBarBackTitleReplace({
  title,
  canReplace = true,
  onBack,
  onReplace,
}: Prop) {
  return (
    <AppBar color="transparent">
      <Toolbar sx={{ backgroundColor: 'transparent' }}>
        <BackButton onClick={onBack} color="neutral000" />
        <TitleTypography color="white" variant="subtitle1">
          {title}
        </TitleTypography>

        {canReplace && (
          <ReplaceButton onClick={onReplace} text={t('chat.replacement')} />
        )}
      </Toolbar>
    </AppBar>
  )
}
